import PropTypes from 'prop-types';

export default function ProgressBar({ value, color, width }) {
  let isFull = [0, 100].includes(value) ? 'full-curve' : '';
  let margin = `${value - 11}%`;
  const MIN_SIZE = 4;
  const MAX_SIZE = 96;
  let psize = 100;
  if (value <= 0) {
    margin = '-7%';
    isFull = 'full-curve';
  } else if (value >= 100) {
    margin = '87%';
    isFull = 'full-curve';
  }
  if (value > 0 && value <= MIN_SIZE) psize = MIN_SIZE;
  else if (value < 100 && value >= MAX_SIZE) psize = MAX_SIZE;
  else if (value > 100) psize = 100;
  else psize = value;

  const generateStyle = (bgcolor, size) => ({
    backgroundColor: bgcolor,
    width: `${size}%`,
  });
  return (
    <div className="progressbar" style={{ width }} data-testid="progress-bar">
      <div className="progressbar-wrapper">
        <span
          className={`progressbar-completed ${isFull}`}
          style={{
            opacity: 1,
            ...generateStyle(color, value > 0 ? psize : 0),
          }}
        >
          &nbsp;&nbsp;
        </span>
        <span
          className={`progressbar-pending ${isFull}`}
          style={{
            opacity: 0.3,
            ...generateStyle(color, 100 - psize),
          }}
        >
          &nbsp;&nbsp;
        </span>
      </div>
      <div className="progressbar-value-wrapper" style={{ marginLeft: margin }}>
        <div className="progressbar-pointer" />
        <p className="progressbar-value">{`${value}%`}</p>
      </div>
    </div>
  );
}

ProgressBar.defaultProps = {
  color: 'blue',
  width: 100,
};

ProgressBar.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  value: PropTypes.number.isRequired,
};
